var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "10px",
    viewBox: "0 0 17 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3EA37AD4-95BC-43F3-BAF6-0CF35D1D35C4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.66111124,13.9951807 L1.54682542,7.98072289 L9.66111124,1.96626506 L9.66111124,0 L0.403968259,6.82409639 C0.0230158733,7.0939759 -0.205555558,7.51807229 -0.205555558,7.98072289 C-0.205555558,8.44337349 0.0230158733,8.86746988 0.403968259,9.1373494 L9.66111124,16 L9.66111124,13.9951807 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fleets-(old_version)",
    transform: "translate(-424.000000, -224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-&-Filters",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regional-Directorate",
    transform: "translate(248.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/01_UI/arrow_down/24---",
    transform: "translate(149.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bouncing-area",
    x: -0.5,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "ERGO_Icon_UI_arrow_left_rgb_black",
    transform: "translate(11.500000, 12.000000) rotate(-90.000000) translate(-11.500000, -12.000000) translate(6.708333, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "02_grey/07_darkest-02_grey/06_darker",
    mask: "url(#mask-2)",
    fill: "#737373"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.333333, -13.000000)",
    id: "Rectangle-Copy-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 40.25 0 40.25 42 0 42"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.3697ab184d16a7dc895e8ace2dabb990.svg";
export { ForwardRef as ReactComponent };